// extracted by mini-css-extract-plugin
export default {"CardContainer":"FAQ_CardContainer__slSug","CardItem":"FAQ_CardItem__fhXku","CardItemQuestion":"FAQ_CardItemQuestion__ue5AF","CardItemAnswer":"FAQ_CardItemAnswer__-84Wa"};